<template>
  <div>
    <div id="map" class="mt-10"></div>
    <div class="col-md-12 col-xs-12 col-sm-12 islands-div" v-if="isIslands">
      The following countries cannot be displayed: Réunion, Seychelles.
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import _ from 'lodash';
import * as d3 from 'd3v4';

export default {
  props: [
    'filteredCountries',
    'countriesList',
    'validateFilter',
    'serviceData',
    'resourceData',
    'countrySelection',
    'EUCountries'
  ],
  data() {
    return {
      countriesFiltered: [],
      servicesLocation: {
        1: {
          url: '/layout/trackplusdashboard',
          route_name: 'TrackplusDashboard'
        },
        2: {
          url: '/layout/regulatoryprocesscharts',
          route_name: 'RegulatoryProcessCharts'
        },
        3: {
          url: '/layout/submission-builder',
          route_name: 'SubmissionBuilder'
        },
        4: {
          url: '/layout/regulatory-updates',
          route_name: 'RegulatoryUpdates'
        },
        5: { url: '/layout/market-place/service/5', route_name: null },
        6: {
          url: '/layout/prodclassification',
          route_name: 'ProdClassification'
        },
        7: {
          url: '/layout/regulatory-pathway',
          route_name: 'RegulatoryPathway'
        }
      },
      eventFunction: '',
      isIslands: false
    };
  },
  watch: {
    filteredCountries() {
      if (Object.keys(this.filteredCountries).length) {
        this.initializeMapData();
      }
    }
  },
  async mounted() {
    this.appendToolTip();
    if (Object.keys(this.filteredCountries).length) {
      this.initializeMapData();
    }
    $('.resource-map-tooltip').on('click', '.redirectLink', (event) => {
      const country = event.target.getAttribute('data-country');
      this.$router.push({
        name: event.target.getAttribute('slot'),
        params: {
          filterCountry:
            event.target.getAttribute('slot') !== 'GuidesAndTemplates'
              ? this.validateEUCountrie(country)
              : country
        }
      });
    });
    this.eventFunction = _.debounce(() => {
      this.initializeMap(this.serviceData, this.resourceData);
    }, 1000);
    window.addEventListener('resize', this.eventFunction);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.eventFunction);
    $('.resource-map-tooltip').remove();
  },
  methods: {
    validateEUCountrie(country) {
      const indexVal = this.EUCountries.indexOf(country);
      return indexVal !== -1 ? 'European Union' : country;
    },
    initializeMapData() {
      this.countriesFiltered = this.filteredCountries;
      this.initializeMap(this.serviceData, this.resourceData);
    },
    appendToolTip() {
      d3.select('.custom-tooltip').remove();
      d3.select('body')
        .append('div')
        .attr('class', 'custom-tooltip resource-map-tooltip')
        .style('display', 'none');

      const tooltip = d3.select('.custom-tooltip');
      tooltip.append('div').attr('class', 'header');
      tooltip.append('div').attr('class', 'body');
      tooltip.append('div').attr('class', 'footer');
    },
    initializeMap(serviceData, resourceData) {
      const that = this;
      this.$emit('loaderEvent', true);
      const width = this.$el.clientWidth;
      let clientHeight = window.innerHeight;
      clientHeight = clientHeight > 1024 ? clientHeight + 300 : clientHeight + 200;
      const windowInnerWidth = window.innerWidth;
      let height = 750;
      let mapScale = 180;
      if (windowInnerWidth < 768) {
        height = 300;
        mapScale = 60;
      }
      if (windowInnerWidth === 768) {
        mapScale = 110;
        height = 470;
      }
      if (windowInnerWidth > 1300) {
        mapScale = 180;
      }
      if (windowInnerWidth > 768 && windowInnerWidth < 1300) {
        mapScale = 150;
        height = 650;
      }
      const countries = this.countriesFiltered;
      const countyList = this.countriesList;
      const filterValid = this.validateFilter;
      const servicesUrl = this.servicesLocation;
      const countrySelected = this.countrySelection;
      const nonZoomCoutries = ['European Union', 'United States of America', 'Russia'];
      const islands = ['Réunion', 'Seychelles'];
      this.isIslands = countrySelected && (countries[islands[0]] || countries[islands[1]]);
      d3.select('#map svg').remove();
      const svg = d3.select('#map').append('svg').attr('width', width).attr('height', height);

      // Initialize Tooltip
      const tooltip = d3.select('.custom-tooltip');
      d3.select('.custom-tooltip').style('display', 'none');
      tooltip
        .on('mouseover', () => {
          d3.select('.custom-tooltip').style('display', 'block');
          d3.select('#prev').style('fill', '#4b9f46');
          d3.select('#prev').style('stroke', '#4b9f46');
        })
        .on('mouseout', () => {
          d3.select('.custom-tooltip').style('display', 'none');
          d3.select('#prev').style('fill', '#0B3C61');
          d3.select('#prev').style('stroke', '#0B3C61');
        });
      d3.json('/static/json/resources-world-map.json', (error, world) => {
        // if (error) throw error;
        const group = svg.selectAll('g').data(world.features).enter().append('g');
        const projection = d3
          .geoMercator()
          .scale(mapScale)
          .translate([width / 2, height / 1.4]);
        const path = d3.geoPath().projection(projection);
        // zoom in zoom out with scroll
        const zoom = d3
          .zoom()
          .scaleExtent([1, 2000])
          .on('zoom', () => {
            group.attr('transform', d3.event.transform);
          });
        svg.call(zoom);
        // Zoom in and out buttons
        let targetScale = d3.zoomTransform(svg).k;
        d3.select('#zoom-in').on('click', () => {
          const scale = targetScale;
          const extent = zoom.scaleExtent();
          const factor = 1.2;
          if (targetScale >= extent[1]) {
            return;
          }
          targetScale = scale * factor;
          svg.transition().duration(500).call(zoom.scaleBy, targetScale);
        });
        d3.select('#zoom-out').on('click', () => {
          const scale = targetScale;
          const extent = zoom.scaleExtent();
          const factor = 1 / 1.2;
          if (targetScale <= extent[0]) {
            return;
          }
          targetScale = scale * factor;
          svg.transition().duration(500).call(zoom.scaleTo, targetScale);
        });
        // Zoom in if single country is selected
        function zoomOnSelectedCountry(d, val) {
          const bounds = path.bounds(d);
          const dx = bounds[1][0] - bounds[0][0];
          const dy = bounds[1][1] - bounds[0][1];
          const x = (bounds[0][0] + bounds[1][0]) / 2;
          const y = (bounds[0][1] + bounds[1][1]) / 2;
          const scale = Math.max(1, Math.min(100, 0.9 / Math.max(dx / width, dy / height)));
          const translate = [width / 2 - scale * x, height / 2 - scale * y];
          if (nonZoomCoutries.indexOf(val.country_name) === -1) {
            svg
              .transition()
              .duration(500)
              .call(
                zoom.transform,
                d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale)
              );
          }
        }
        // initialize Tooltip
        function addToolTip(toolTipData, country) {
          let services = '';
          let resources = '';
          for (let i = 0; i < toolTipData.resources.length; i += 1) {
            resources += `<div class="custom-tooltip-header resource-map-tooltip-txt"><a class="redirectLink cursor-pointer" slot="${
              resourceData[toolTipData.resources[i]].route_name
            }" data-country="${country.country_name}">${
              resourceData[toolTipData.resources[i]].name
            }</a></div>`;
          }
          for (let i = 0; i < toolTipData.services.length; i += 1) {
            services += `<div class="custom-tooltip-header resource-map-tooltip-txt"><a class="redirectLink cursor-pointer" slot="${
              servicesUrl[toolTipData.services[i]].route_name
            }" data-country="${country.country_name}">${
              serviceData[toolTipData.services[i]].name
            }</a></div>`;
          }
          d3.select('.custom-tooltip .header').html(
            `<span class="resource-tooltip-flag flag-icon custom-flag-icon flag-icon-squared flag-icon-${toolTipData.country_code.toLowerCase()} country_flag"></span>` +
              `<span class="custom-country-name">${toolTipData.country_name}</span>` +
              `<span class="custom-count">(${
                toolTipData.resources.length + toolTipData.services.length
              })</span>`
          );
          d3.select('.custom-tooltip .body').html('');
          if (toolTipData.resources.length) {
            d3.select('.custom-tooltip .body').html(
              `<div class="custom-tooltip-header resource-map-tooltip-header">Free resources (${toolTipData.resources.length})</div>${resources}`
            );
          }
          d3.select('.custom-tooltip .footer').html('');
          if (toolTipData.services.length) {
            d3.select('.custom-tooltip .footer').html(
              `<div class="custom-tooltip-header resource-map-tooltip-header">Premium services (${toolTipData.services.length})</div>${services}`
            );
          }
          d3.select('.custom-tooltip').style('display', 'block');
        }
        group
          .append('path')
          .attr('d', path)
          .attr('class', 'area')
          .attr('stroke', (d) => {
            const countryData = countries[d.properties.admin];
            const Eu = countries[d.properties.region_un];
            let val = countryData;
            if (!countryData && Eu) {
              val = Eu;
            }
            if (val) {
              if (filterValid || val.resources.length || val.services.length) {
                if (countrySelected) {
                  zoomOnSelectedCountry(d, val);
                }
                return '#0B3C61';
              }
            }
            return '#fff';
          })
          .attr('stroke-width', (d) => {
            const countryData = countries[d.properties.admin];
            const Eu = countries[d.properties.region_un];
            let val = countryData;
            if (!countryData && Eu) {
              val = Eu;
            }
            let value = 0.1;
            if (val) {
              if (filterValid || val.resources.length || val.services.length) {
                if (
                  d.properties.admin === 'United States Minor Outlying Islands' ||
                  d.properties.admin === 'Kiribati'
                ) {
                  value = 2;
                }
                if (countrySelected) {
                  zoomOnSelectedCountry(d, val);
                }
                return value;
              }
            }
            return value;
          })
          .attr('fill', (d) => {
            const countryData = countries[d.properties.admin];
            const Eu = countries[d.properties.region_un];
            let val = countryData;
            if (!countryData && Eu) {
              val = Eu;
            }
            if (val) {
              if (filterValid || val.resources.length || val.services.length) {
                if (countrySelected) {
                  zoomOnSelectedCountry(d, val);
                }
                return '#0B3C61';
              }
            }
            return '#e6e6e6';
          })
          .on('click', zoomOnSelectedCountry)
          .on('mouseover', function (d) {
            // eslint-disable-line
            d3.select('#prev').style('fill', '#0B3C61');
            d3.select('#prev').attr('id', '');
            const countryData = countries[d.properties.admin];
            const Eu = countries[d.properties.region_un];
            let toolTipData = countyList[d.properties.admin];
            let country = countryData;
            if (!countryData && Eu) {
              country = Eu;
              toolTipData = countyList[d.properties.region_un];
            }
            if (country) {
              if (filterValid || country.resources.length || country.services.length) {
                const tooltipX = d3.event.pageX + 280 > width ? 280 : 0;
                d3.select(this).style('fill', '#4b9f46');
                d3.select(this).style('stroke', '#4b9f46');
                d3.select(this).attr('id', 'prev');
                addToolTip(toolTipData, country);
                const toolTipSelector = $('.custom-tooltip');
                const tooltipY =
                  d3.event.pageY + toolTipSelector.outerHeight(true) > clientHeight
                    ? d3.event.pageY - toolTipSelector.outerHeight(true)
                    : d3.event.pageY;
                tooltip
                  .style('left', `${d3.event.pageX - tooltipX}px`)
                  .style('top', `${tooltipY}px`);
              }
            }
          })
          .on('mouseout', function (d) {
            // eslint-disable-line
            const countryData = countries[d.properties.admin];
            const Eu = countries[d.properties.region_un];
            let val = countryData;
            if (!countryData && Eu) {
              val = Eu;
            }
            if (val) {
              if (filterValid || val.resources.length || val.services.length) {
                d3.select(this).style('fill', '#0B3C61');
                d3.select(this).style('stroke', '#0B3C61');
                d3.select('.custom-tooltip').style('display', 'none');
              }
            }
          });
        const legendColor = ['#0B3C61', '#D3D6D9'];
        const legend = svg
          .append('g')
          .attr('class', 'resource_legend_svg')
          .attr('font-size', 10)
          .attr('text-anchor', 'start')
          .attr('transform', `translate(0,${height - 30})`)
          .selectAll('g')
          .data(['Resource(s) available', 'No resources available'])
          .enter()
          .append('g')
          .attr('transform', (d, i) => `translate(0,${i * 10 + i * 8})`);

        legend
          .append('rect')
          .attr('width', 12)
          .attr('height', 12)
          .attr('fill', (d, i) => legendColor[i]);

        legend
          .append('text')
          .style('font-family', 'Roboto')
          .style('font-size', '12px')
          .style('font-weight', 'normal')
          .attr('fill', '#000000')
          .attr('x', 15)
          .attr('y', 10)
          .text((d) => d);
        that.$emit('loaderEvent', false);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.islands-div {
  color: $shuttle-grey;
  font-size: $font-12;
  padding: 25px 10px 10px 0px;
}
.avail-resources {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: $primary;
  border-radius: 1px;
}
.no-resources {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: #d3d6d9;
  border-radius: 1px;
}
.legend-txt {
  margin-left: 5px;
  display: inline-block;
  font-style: normal;
  @include fontItems($font-12, 12px, $font-weight-normal);
  color: $black;
}
.legend-wrapper {
  display: none;
}
::v-deep .spinnerTop {
  position: absolute;
  left: 0;
  .spinner {
    position: absolute;
    left: 8%;
  }
}
@media screen and (max-width: 767px) {
  ::v-deep .resource_legend_svg {
    display: block;
  }
}
</style>
